import Model from '@/models/Model'

export default class SlCustomerPresetsDiscount extends Model {
    resource() {
        return 'sl_customer_presets_charge'
    }
}